import eventBus from '@/utils/EventBus'

const MAX_LEN_REALTIME_SAMPLES = 500;

const state = {
    listeningRelatime: false,
    listeningAIRealtime: false,
    selectedAIDevice: null,
    telemetry: [],
    geoLocations: [],
    events: [],
    aiEvents: [],
    measuresAvailable: [
        {
            id: "tem",
            label:"Temperature (°C)",
            unit:{
                value:1,
                label:"°C"
            },
            scalar: true,
            default: true
        },
        {
            id: "pre",
            label:"Pressure (hPa)",
            unit:{
                value:1,
                label:"hPa"
            },
            scalar: true,
            default: true
        },
        {
            id: "hum",
            label: "Humidity (%)",
            unit:{
                value:1,
                label:"o/o"
            },
            scalar: true,
            default: true
        },
        {
            id: "acc",
            label: "Accelerometer (mg)",
            unit:{
                value:0.001,
                label:"g"
            },
            scalar: false,
            dimensions: ['x','y','z'],
            default: true
        },
        {
            id: "gyr",
            label: "Gyroscope (mdps)",
            unit:{
                value:0.001,
                label:"dps"
            },
            scalar: false,
            dimensions: ['x','y','z'],
            default: true
        },
        {
            id: "mag",
            label: "Magnetometer (mgauss)",
            unit:{
                value:0.001,
                label:"gauss"
            },
            scalar: false,
            dimensions: ['x','y','z'],
            default: true
        }  
    ]
}

const getters = {

}

const actions = {
    init({ commit }) {
        eventBus.$on(
            "events",
            (events) => {
                commit('appendEvents', events)
            })

        eventBus.$on(
            "telemetry",
            (telemetry) => {
                commit('appendTelemetry', telemetry)
                commit('updateMeasuresAvailable', telemetry)
            }
        )
        eventBus.$on(
            "geolocation",
            (geoLocations) => {
                commit('appendGeoLocation', geoLocations)
            }
        )
        eventBus.$on(
            "ai",
            (aiEvent) => {
                commit('appendAIEvents', aiEvent)
            }
        )
    },
    deinit({ commit }) {
        return new Promise(
            (resolve) => {
                commit('clearTelemetry')
                commit('clearAIEvents')
                resolve()
            }
        )
    },


    startTelemetryReltime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', true)
                commit('updateTelemetry', [])
                resolve()
            }
        )
    },

    stopTelemetryRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', false)
                resolve()
            }
        )
    },

    startGeoLocationRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', true)
                commit('updateGeoLocations', [])
                resolve()
            }
        )
    },

    stopGeoLocationRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', false)
                resolve()
            }
        )
    },

    startEventsRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', true)
                commit('updateEvents', [])
                resolve()
            }
        )
    },

    stopEventsRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenRealtime', false)
                resolve()
            }
        )
    },

    startAIRealtime({ commit }) {
        return new Promise(
            (resolve) => {

                commit('listenAIRealtime', true)
                resolve()
            }
        )
    },

    stopAIRealtime({ commit }) {
        return new Promise(
            (resolve) => {
                commit('listenAIRealtime', false)
                resolve()
            }
        )
    },

    fetchTelemetry: function ({ rootState, commit }, parameters) {
        let ids = parameters.devices.map((device) => device.id)
        let start = parameters.startTime
        let end = parameters.endTime
        return new Promise(
            function (resolve, reject) {
                commit('startOperation', 'Fetching telemetry', { root: true })
                rootState.serviceModule.deviceManager.GetTelemetry(ids, start, end)
                    .then((telemetry) => {
                        commit('stopOperation', null, { root: true })
                        commit('successLastOperationPerformed', 'Telemetry fetched', { root: true })
                        commit('updateTelemetry', telemetry)
                        commit('updateMeasuresAvailable', telemetry)
                        resolve()
                    })
                    .catch((err) => {
                        commit('stopOperation', null, { root: true })
                        commit('errorLastOperationPerformed', 'Fetching telemetry failed', { root: true })
                        reject(err)
                    })
            }
        )
    },
    fetchGeoLocations: function ({ rootState, commit }, parameters) {
        let ids = parameters.devices.map((device) => device.id)
        let start = parameters.startTime
        let end = parameters.endTime
        return new Promise(
            function (resolve, reject) {
                commit('startOperation', 'Fetching geo-locations', { root: true })
                rootState.serviceModule.deviceManager.GetGeoLocations(ids, start, end)
                    .then((geoLocations) => {
                        commit('stopOperation', null, { root: true })
                        commit('successLastOperationPerformed', 'Geo-locations fetched', { root: true })
                        commit('updateGeoLocations', geoLocations)
                        resolve()
                    })
                    .catch((err) => {
                        commit('stopOperation', null, { root: true })
                        commit('errorLastOperationPerformed', 'Fetching geo-locations failed', { root: true })
                        reject(err)
                    })
            }
        )
    },
    fetchEvents: function ({ rootState, commit }, parameters) {
        let ids = parameters.devices.map((device) => device.id)
        let start = parameters.startTime
        let end = parameters.endTime
        return new Promise(
            function (resolve, reject) {
                commit('startOperation', 'Fetching events', { root: true })
                rootState.serviceModule.deviceManager.GetEvents(ids, start, end)
                    .then((events) => {
                        commit('stopOperation', null, { root: true })
                        commit('successLastOperationPerformed', 'Events fetched', { root: true })
                        commit('updateEvents', events)
                        resolve()
                    })
                    .catch((err) => {
                        commit('stopOperation', null, { root: true })
                        commit('errorLastOperationPerformed', 'Fetching events failed', { root: true })
                        reject(err)
                    })
            }
        )
    },

    downloadRawData: function ({ rootState, commit }, parameters) {
        let saveData = function (data, fileName) {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            // console.log(data)
            // var blob = new Blob(data.split(), { type: "application/zip" }),
            const url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }

        let ids = parameters.devices.map((device) => device.id)
        let start = parameters.startTime;
        let end = parameters.endTime;
        return new Promise(
            function (resolve, reject) {
                commit('startOperation', 'Download raw data', { root: true })
                rootState.serviceModule.deviceManager.GetRawData(ids, start, end)
                    .then(async (data) => {
                        commit('stopOperation', null, { root: true })
                        commit('successLastOperationPerformed', 'Data dowloaded', { root: true })

                        // const newHandle =  await (function getNewFileHandle() {
                        //     const opts = {
                        //         types: [{
                        //             description: 'Telemetry data - zip file',
                        //             accept: { 'application/zip': ['.zip'] },
                        //         }],
                        //     };
                        //     return window.showSaveFilePicker(opts);
                        // })()
                        // const writableStream = await newHandle.createWritable();
                        // writableStream.write(data);
                        // await writableStream.close();
                        const startPrefix = String(start.getMonth()+1).padStart(2, '0') + String(start.getDate()).padStart(2, '0') + "" + start.getFullYear();
                        const endPrefix = String(end.getMonth()+1).padStart(2, '0') + String(end.getDate()).padStart(2, '0') + "" + end.getFullYear();
                        const filename = `${ids.join("_")}_${startPrefix}_${endPrefix}`;
                        saveData(data, filename);
                        resolve();
                    })
                    .catch((err) => {
                        commit('stopOperation', null, { root: true })
                        commit('errorLastOperationPerformed', 'Downloading failed', { root: true })
                        reject(err)
                    })
            }
        )
    },
}

const mutations = {
    updateTelemetry(state, telemetry) {
        state.telemetry = telemetry;
    },
    updateGeoLocations(state, geoLocations) {
        state.geoLocations = geoLocations;
    },
    updateEvents(state, events) {
        state.events = events;
    },
    appendTelemetry(state, telemetry) {
        if (state.listeningRelatime)
            telemetry.forEach(
                (deviceData) => {
                    let telemetry = state.telemetry.filter(data => data.id == deviceData.id);

                    if (telemetry.length <= 0) {
                        state.telemetry.push(deviceData);
                    } else {
                        telemetry[0].data = telemetry[0].data.concat(deviceData.data);
                    }

                    if (telemetry[0].data.length > MAX_LEN_REALTIME_SAMPLES) {
                        telemetry[0].data.slice(telemetry[0].data.length - MAX_LEN_REALTIME_SAMPLES);
                    }
                    telemetry[0].data.sort((t1, t2) => t2.timestamp > t1.timestamp ? -1 : 1);
                }
            )
    },
    appendGeoLocation(state, geoLocations) {
        if (state.listeningRelatime)
            geoLocations.forEach(
                (deviceData) => {
                    let geoLocations = state.geoLocations.filter(data => data.id == deviceData.id)
                    if (geoLocations.length <= 0) {
                        state.geoLocations.push(deviceData);
                    } else {
                        geoLocations[0].data = geoLocations[0].data.concat(deviceData.data);
                    }

                    if (geoLocations[0].data.length > MAX_LEN_REALTIME_SAMPLES) {
                        geoLocations[0].data.slice(geoLocations[0].data.length - MAX_LEN_REALTIME_SAMPLES);
                    }
                    geoLocations[0].data.sort((g1, g2) => g2.timestamp > g1.timestamp ? -1 : 1);
                }
            )
    },
    appendEvents(state, events) {
        if (state.listeningRelatime)
            events.forEach(
                (deviceData) => {
                    let events = state.events.filter(data => data.id == deviceData.id);

                    if (events.length <= 0) {
                        state.events.push(deviceData)
                    } else {
                        events[0].data = events[0].data.concat(deviceData.data);
                    }

                    if (events[0].data.length > MAX_LEN_REALTIME_SAMPLES) {
                        events[0].data.slice(events[0].data.length - MAX_LEN_REALTIME_SAMPLES);
                    }
                    events[0].data.sort((e1, e2) => e2.timestamp > e1.timestamp ? -1 : 1);
                }
            )
    },
    clearTelemetry(state) {
        state.telemetry.slice(0);
    },

    clearEvents(state) {
        state.events.slice(0);
    },

    appendAIEvents(state, aiEvent) {
        if (state.listeningAIRealtime) {
            state.aiEvents.push(aiEvent)
            if (state.aiEvents.length > 100)
                state.aiEvents.slice(1)
        }
    },
    clearAIEvents(state) {
        state.aiEvents.slice(0);
    },

    listenRealtime(state, value) {
        state.listeningRelatime = value
    },

    listenAIRealtime(state, value) {
        state.listeningAIRealtime = value
    },

    updateMeasuresAvailable(state, telemetry) {
        state.measuresAvailable = state.measuresAvailable.filter(ma => ma.default);
        let measuresAvailableMap = {};
        for (const deviceTelemetry of telemetry) {
            deviceTelemetry.data.forEach(sample => { 
                Object.keys(sample).forEach(measureName => {
                    switch (measureName) {
                        case "timestamp":
                        case "ts":
                        case "gnss":
                            break;          
                        default:
                            // if(!measuresAvailableMap[measureName]){
                                if(typeof sample[measureName] === "object"){
                                    measuresAvailableMap[measureName] = {
                                        id: measureName,
                                        label: measureName.toUpperCase(),
                                        scalar: false,
                                        dimensions: Object.keys(sample[measureName]),
                                        unit:{
                                            value:1,
                                            label:""
                                        }
                                    };
                                } else {
                                    measuresAvailableMap[measureName] = {
                                        id: measureName,
                                        label: measureName.toUpperCase(),
                                        scalar: true,
                                        unit:{
                                            value:1,
                                            label:""
                                        }
                                    };
                                }
                            // }
                            break;
                    } 
                });
            });

        }
        for(const measureName of Object.keys(measuresAvailableMap)) {
            if(!state.measuresAvailable.find(ma => ma.id === measureName)){
                state.measuresAvailable.push(measuresAvailableMap[measureName]);
            }
        }
    }
}


export default {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced: true
}